import { render } from "./BackTo.vue?vue&type=template&id=0052cc45&bindings={\"link\":\"props\",\"label\":\"props\"}"
import script from "./BackTo.vue?vue&type=script&lang=ts"
export * from "./BackTo.vue?vue&type=script&lang=ts"

import "./BackTo.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script